export default "__VITE_ASSET__Dqi3P6eG__"